module.exports = __webpack_public_path__ + "img/webmegler.75ab09a3.png";